import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const EcuadorFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14632'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14632)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 10.2667H20V6.53333H0V10.2667Z'
					fill='#0748AE'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14.0001H20V10.2667H0V14.0001Z'
					fill='#DE2035'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 6.53333H20V0H0V6.53333Z'
					fill='#FFD935'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.85757 5.59998C8.39495 5.94053 8.0957 6.48273 8.0957 7.09342C8.0957 8.12435 8.94849 8.96009 10.0005 8.96009C11.0524 8.96009 11.9052 8.12435 11.9052 7.09342C11.9052 6.48273 11.606 5.94053 11.1434 5.59998L10.4767 7.56009H9.52427L8.85757 5.59998Z'
					fill='#FFD935'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99963 5.1333L10.4758 7.46663H9.52344L9.99963 5.1333Z'
					fill='#5FC0DC'
				/>
				<path
					opacity='0.66'
					d='M12.381 4.19994L10.9525 3.73328L10.0001 4.66661L9.04771 3.73328L7.61914 4.19994'
					stroke='#3F2821'
					strokeWidth='0.666667'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
		</svg>
	);
};

export default EcuadorFlagIcon;
